import { render, staticRenderFns } from "./policyDownload.vue?vue&type=template&id=4df1f57c&scoped=true&"
import script from "./policyDownload.vue?vue&type=script&lang=js&"
export * from "./policyDownload.vue?vue&type=script&lang=js&"
import style0 from "./policyDownload.vue?vue&type=style&index=0&id=4df1f57c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df1f57c",
  null
  
)

export default component.exports